import React, { FC }                 from 'react';
import styled                        from 'styled-components';
import { DataTable, Button }         from '@components/index';
import { TDataTableRow }             from '@typings/components';
import { ISalesPerson }              from '@typings/accountManagement';
import { SALESPERSON_TABLE_HEADERS } from '../utils/tableHeaders';
import { AddSalesPersonModal }       from '../components/AddSalesPersonModal';

const Wrapper = styled.div`
  width: 80%;
`;

const ButtonWrapper = styled.div`
  display         : flex;
  justify-content : flex-end;
  margin-right    : 90px;
`;

interface IProps {
  tableRows             : TDataTableRow[];
  isModalOpen           : boolean;
  onAddSalesPersonClose : () => void;
  handleSaveSalesperson : (data: ISalesPerson) => Promise<void>;
  handleAddSalesPerson  : (data: ISalesPerson | null) => void;
  currentSalesPerson    : ISalesPerson | null;
  isUpdating            : boolean;
}

export const SalespersonPage: FC<IProps> = ({
  tableRows,
  isModalOpen,
  onAddSalesPersonClose,
  handleSaveSalesperson,
  currentSalesPerson,
  handleAddSalesPerson,
  isUpdating,
}) => (
  <Wrapper>
    <DataTable
      headers = {SALESPERSON_TABLE_HEADERS}
      rows    = {tableRows}
      margin  = "20px 30px"
    />

    <AddSalesPersonModal
      isOpen                = {isModalOpen}
      onCancel              = {onAddSalesPersonClose}
      handleSaveSalesperson = {handleSaveSalesperson}
      salesPerson           = {currentSalesPerson}
      isUpdating            = {isUpdating}
    />

    <ButtonWrapper>
      <Button
        label   = "Add Salesperson"
        width   = "180px"
        margin  = "20px 0 0"
        onClick = {() => handleAddSalesPerson(null)}
      />
    </ButtonWrapper>
  </Wrapper>
);
